notifications-index
  notifications-table(tag-scope="notifications_table")
  script(type="typescript").
    this.mixin('base');
